import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { TokenStorage } from 'src/app/util/token.storage';
import { OrganizationService } from 'src/app/services/organization.service';
import { Lookup } from 'src/app/model/lookup';
import { LookupService } from 'src/app/services/lookup.service';
import { AuthenticationService } from "src/app/services/authentication.service";
import { ZoneService } from 'src/app/services/zone.service';
import { GeofenceService } from "src/app/services/geofence.service";
import { GeofenceZoneService } from "src/app/services/geofencezone.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-zone-view-dialog",
  templateUrl: "./zone-view-dialog.component.html",
  styleUrls: ["./zone-view-dialog.component.scss"]
})
export class ZoneViewDialogComponent implements OnInit {
  public form: any;
  public roleList: Lookup[] = [];
  public adminRole: any;
  public orgId: number;
  public organizationList: Lookup[] = [];
  public isStatus: boolean = true;
  public zoneData: any;
  public selectedZone: any
  public dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  tempId: any;
  allZoneData: any;

  constructor(public dialogRef: MatDialogRef<ZoneViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public organizationService: OrganizationService,
    public geofenceService: GeofenceService,
    public geofenceZoneService: GeofenceZoneService,
    public zoneService: ZoneService,
    public tokenStorage: TokenStorage,
    public toastrService: ToastrService,
    public authenticationService: AuthenticationService,
    public lookupService: LookupService) {}

    public displayedColumns: string[] = [
      'zoneId',
      'zoneName',
      'actions'
    ];

  ngOnInit() {
    this.getAllZone();
    this.getAllGeofenceZone();
    this.adminRole = this.authenticationService.currentUserValue.role;
    this.orgId = this.authenticationService.currentUserValue.organizationId;
  }

  getAllZone(): void {
    this.zoneService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.allZoneData = response.data;
          // console.log("All Zone", this.zoneData);
        } else {
          console.log("Zone API Error!");
        }
      });
  }

  getZoneName(zone){
    let myObj = this.allZoneData.filter(x=>x.zoneId == zone.zoneId)[0];
    // console.log("filter zone",myObj);
    if(myObj == undefined){
      let myZone = "Zone Deleted!";
      return myZone;
    }
    else{
      let myZone = Object.assign({},myObj);
      // console.log(myZone);
      return myZone.zoneName;
    }
  }

  getAllGeofenceZone(): void {
    this.geofenceZoneService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.zoneData = response.data.filter(x=>x.geofenceId == this.data.geofenceId);
          this.dataSource = new MatTableDataSource<unknown>(this.zoneData);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          console.log("Zone API Error!");
        }
      });
  }
  
  deleteGeoFenceZone(payload: any){
    this.geofenceZoneService.deleteGeofenceZone(payload.id).pipe(first()).subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.toastrService.success(response.value, "Zone Deleted Successfully!");
        this.getAllGeofenceZone();
      }
    })
  }

  getTempId(obj: any){
    this.tempId = obj;
    setTimeout(()=>{
      document.querySelector('.modal-backdrop.fade.show').classList.add('d-none');
    },500)
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }
}